module.exports = "<div class=\"center-wrap\">\n  <div class=\"center empty-state\">\n    Some settings would be nice.\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/settings/settings.component.html
// module id = ../../../../../src/app/settings/settings.component.html
// module chunks = main